var __TEMP__ = require('./_createRound.js');var createRound = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Computes `number` rounded to `precision`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Math
 * @param {number} number The number to round.
 * @param {number} [precision=0] The precision to round to.
 * @returns {number} Returns the rounded number.
 * @example
 *
 * _.round(4.006);
 * // => 4
 *
 * _.round(4.006, 2);
 * // => 4.01
 *
 * _.round(4060, -2);
 * // => 4100
 */
var round = createRound('round');

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = round;
